import { colorPalette } from '../../colorPalette';
export const useStyles = () => ({
    rankProgression: {
        display: "flex",
        alignItems: "center",
        backgroundColor: colorPalette.white,
        boxShadow: "0 3px 20px rgba(74, 74, 74, 0.14)",
        borderRadius: "4px",
        overflow: "hidden",
        marginTop: "14px",
        padding: "16px",
    },
    rankProgression_leftside: {
        marginRight: "16px",
    },
    rankProgression_percentage: {
        height: "38px",
        width: "38px",
        lineHeight: "38px",
        textAlign: "center",
        borderWidth: "4px",
        borderStyle: "solid",
        borderRadius: "30px",
    },
    rankProgression_percentage_span: {
        fontWeight: "bold",
        fontSize: "12px",
    },
    rs_title: {
        textTransform: "uppercase",
        fontWeight: "600",
        fontSize: "10px",
        lineHeight: "14px",
        color: colorPalette.gray700,
        opacity: "0.6",
        margin: "0",
    },
    rs_rankingPhrase: {
        fontSize: "14px",
        lineHeight: "18px",
        color: colorPalette.gray800,
    },
    rs_rankingPhrase_p: {
        marginTop: "4px",
        marginBottom: "0",
    }
});
